module.exports = __webpack_public_path__ + "img/loading 2.fdf492f1.svg";